export default {"src":"/_next/static/media/WhoWeAre_013A.7febdf59.JPG","height":682,"width":1920};